function needsQuotes(key) {
  return /\s|-/.test(key);
}
export {
  needsQuotes
};
//# sourceMappingURL=needsQuotes.js.map
